import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../../../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import Input from "../../../../../../../components/textbox/Input";
import Utils from "../../../../../../../utils/Utils";
import Calendar from "../../../../../../../components/calendar/Calendar";
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json"

class DatiDelCompilatoreMorbillo extends Component {

    state = {
        datiDelCompilatore: {
            nomeECognome: "",
            recapitoTelefonico: "",
            dataDiNotificaAllaRegione: "",
            note: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        let datiDelCompilatore = this.state.datiDelCompilatore
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiDelCompilatore) {
            let datiDelCompilatoreCopia = this.props.segnalazioneCopia.schedaSpeciale.datiDelCompilatore
            for (let key in datiDelCompilatore) {
                if (datiDelCompilatore.hasOwnProperty(key) === datiDelCompilatoreCopia.hasOwnProperty(key)) {
                    datiDelCompilatore[key] = datiDelCompilatoreCopia[key]
                } else {
                    datiDelCompilatore[key] = ""
                }
            }
            this.setState({datiDelCompilatore: datiDelCompilatore})
            let corretto = this.controlloCorrettezza()
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("datiDelCompilatore", oggettoBE, corretto)

        } else {
            let corretto = this.controlloCorrettezza()
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("datiDelCompilatore", oggettoBE, corretto)
        }
    }

    validate() {

        if (this.state.datiDelCompilatore.dataDiNotificaAllaRegione && Utils.validateDate(this.state.datiDelCompilatore.dataDiNotificaAllaRegione, "Messages.DataNotifica", "Messages.DataNotificaOdierna")) {
            return Utils.validateDate(this.state.datiDelCompilatore.dataDiNotificaAllaRegione, "Messages.DataNotifica", "Messages.DataNotificaOdierna")
        }

        return ""

    }

    riceviValore(field, event) {
        let datiDelCompilatore = this.state.datiDelCompilatore
        datiDelCompilatore[field] = event.target.value
        this.setState({datiDelCompilatore: datiDelCompilatore})
        let corretto = this.controlloCorrettezza()
        let oggettoBE = this.createObjectBE()
        this.props.createOggettoBeAndcontrolloCorrettezza("datiDelCompilatore", oggettoBE, corretto, this.validate())
    }

    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.datiDelCompilatore))
        Utils.removeFieldFromObject(oggettoBE, "corretto")
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }

    controlloCorrettezza() {
        let datiDelCompilatore = this.state.datiDelCompilatore
        datiDelCompilatore.corretto = []

        if (datiDelCompilatore.dataDiNotificaAllaRegione &&
            Utils.isDateInValid(Utils.transformDateForBackend(datiDelCompilatore.dataDiNotificaAllaRegione), "-")) datiDelCompilatore.corretto[0] = "Campo \"Data di notifica alla Regione\" mancante o errato";

        return datiDelCompilatore.corretto

    }


    render() {
        const {t} = this.props

        const datiDelCompilatore = (

            <div className={"container"}>
                <div className={"row"}>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                        <p style={{color: "#1b7ea9"}}>
                            {t("SchedaSpecialeMorbillo.cognomeNome")}
                        </p>
                        <Input id={"nomeECognome"}
                               onChange={this.riceviValore}
                               field={"nomeECognome"}
                               value={this.state.datiDelCompilatore.nomeECognome}
                               placeholder={t("SchedaSpecialeMorbillo.cognomeNome")}/>
                    </div>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                        <p style={{color: "#1b7ea9"}}>
                            {t("SchedaSpecialeMorbillo.recapitoTelefonico")}
                        </p>
                        <Input id={"recapitoTelefonico"}
                               onChange={this.riceviValore}
                               field={"recapitoTelefonico"}
                               value={this.state.datiDelCompilatore.recapitoTelefonico}
                               placeholder={t("SchedaSpecialeMorbillo.recapitoTelefonico")}/>
                    </div>
                    <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                        <p style={{color: "#1b7ea9"}}>
                            {t("SchedaSpecialeMorbillo.dataDiNotificaAllaRegione")}
                        </p>
                        <Calendar
                            id={"dataDiNotificaAllaRegione"}
                            value={this.state.datiDelCompilatore.dataDiNotificaAllaRegione}
                            field={"dataDiNotificaAllaRegione"}
                            onChange={this.riceviValore}
                            newCalendar={true}
                            errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataDiNotificaAllaRegione"))}
                            error={(this.state.datiDelCompilatore.dataDiNotificaAllaRegione === "" || this.state.datiDelCompilatore.dataDiNotificaAllaRegione == null) ? false :
                                Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiDelCompilatore.dataDiNotificaAllaRegione), "-")
                            }
                        >
                        </Calendar>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-lg-8"}>
                        <p style={{color: "#1b7ea9"}}>
                            {t("SchedaSpecialeMorbillo.note")}
                        </p>
                        <Input id={"note"}
                               onChange={this.riceviValore}
                               field={"note"}
                               type={"textarea"}
                               value={this.state.datiDelCompilatore.note}
                               placeholder={t("SchedaSpecialeMorbillo.note")}/>
                    </div>
                </div>
            </div>
        )

        return (
            <div style={{marginTop: "2rem", marginBottom: "2rem"}}>
                <h6>{t("SchedaSpecialeMorbillo.datiDelCompilatore")}</h6>
                <hr className={styles.hr}/>
                {datiDelCompilatore}
            </div>
        );
    }
}

export default withTranslation('common')(DatiDelCompilatoreMorbillo)
